module.exports = __webpack_public_path__ + "img/mainbackground.fd7a0910.png";